import Delete from "@mui/icons-material/Delete";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid2 from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { getFieldPath } from "../../Common/SchemaUtils";

const CheckboxFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
  remove?: Function;
}> = ({ extractionId, extractionPath, label, remove }) => {
  const { control } = useFormContext();
  return (
    <Grid2 container spacing={2} sx={{ alignItems: "center" }}>
      <Grid2 size={remove !== undefined ? 11 : 12}>
        <FormControlLabel
          control={
            <Controller
              name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}`}
              control={control}
              render={({ field: props }) => (
                <Checkbox
                  {...props}
                  checked={props.value}
                  onChange={(e) => props.onChange(e.target.checked)}
                />
              )}
            />
          }
          label={label}
        />
      </Grid2>
      {remove !== undefined && (
        <Grid2 size={2} sx={{ textAlign: "right", pt: 0.5 }}>
          <IconButton
            onClick={() => {
              remove();
            }}
            className="rounded-full"
            size="small"
          >
            <Delete color="error" />
          </IconButton>
        </Grid2>
      )}
    </Grid2>
  );
};

export default CheckboxFormFields;
